import { State_update, Types_Msg$4, State_init } from "../ThreeDocs.Client.StateMachine.Crud/CrudComponent.js";
import { SectionsUpdateArgs, CustomShared_get_practiceMedia_, CustomShared_get_publicMedia_, CustomShared_get_currentRoles_, CustomShared, SectionsCrudConfig_SectionVmModelConfig, SectionsCrudConfig_SectionVmViewConfig, SectionsCrudConfig_generalViewLayoutConfig } from "./Sections/SectionsCrudConfig.js";
import { filter, append as append_1, cons, ofArray, singleton, map, empty } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { emptyPackageWithDefaults, Model, ViewMode as ViewMode_1, Msg } from "./PackageTypes.js";
import { Sort_SortInfo$1, Sort_SortDirection, Sort_SortableColumn$1, Sort_Compare$1 } from "../ThreeDocs.SharedUI/Sort.js";
import { PackageViewModel, PackageViewModel_get_empty } from "../ThreeDocs.Models/View/PackageViewModel.js";
import { Cmd_none, Cmd_map, Cmd_batch } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.25.0/Seq.js";
import { some } from "../fable_modules/fable-library-js.4.25.0/Option.js";
import { Optic_Set, Optic_Set_op_HatEquals_2170E4F5 } from "../fable_modules/Fable.Aether.1.0.2/Aether.fs.js";
import { Shared_CrudInbound$2 } from "../ThreeDocs.Client.StateMachine.Crud/SharedCrud.js";
import { Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "../fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { securedApi } from "../Api.js";
import { newGuid } from "../fable_modules/fable-library-js.4.25.0/Guid.js";
import { success, error } from "../ThreeDocs.SharedUI/Toast.js";
import { ErrorMessage_get_describe } from "../ThreeDocs.Models/Api/Api.js";
import { SectionViewModel } from "../ThreeDocs.Models/View/SectionViewModel.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.25.0/Result.js";
import { InternalMsg$4 } from "../ThreeDocs.Client.StateMachine.Crud/CrudSubstates/CrudDataEntryState.js";
import { CrudStateMachine_CrudTaggedStateMessages$4 } from "../ThreeDocs.Client.StateMachine.Crud/CrudMachine.js";
import { StateMachineMsg$5 } from "../fable_modules/Webbler.StateMachine.Core.1.3.1/StateMachine.fs.js";
import { InternalMsg$4 as InternalMsg$4_1 } from "../ThreeDocs.Client.StateMachine.Crud/CrudSubstates/CrudDeleteConfirmationState.js";

export function init(maybePracticeId, currentRoles) {
    const patternInput = State_init(SectionsCrudConfig_generalViewLayoutConfig(SectionsCrudConfig_SectionVmViewConfig.viewListItemConfig.listColumns, SectionsCrudConfig_SectionVmModelConfig.isSameItem), SectionsCrudConfig_SectionVmViewConfig, SectionsCrudConfig_SectionVmModelConfig, new CustomShared(currentRoles, empty(), empty()));
    let packagesCommands;
    if (maybePracticeId == null) {
        packagesCommands = empty();
    }
    else {
        const practiceId = maybePracticeId;
        packagesCommands = map((msg) => singleton((dispatch) => {
            dispatch(msg);
        }), ofArray([new Msg(2, [practiceId]), new Msg(4, [practiceId]), new Msg(6, []), new Msg(8, [practiceId])]));
    }
    return [new Model(empty(), undefined, new Sort_SortInfo$1(new Sort_SortableColumn$1("", (_arg) => "", new Sort_Compare$1((_arg_1, _arg_2) => 0)), new Sort_SortDirection(1, [])), PackageViewModel_get_empty(), new ViewMode_1(0, []), currentRoles, patternInput[0]), Cmd_batch(toList(delay(() => append(singleton_1(Cmd_map((Item_1) => (new Msg(18, [Item_1])), patternInput[1])), delay(() => packagesCommands)))))];
}

export function update(token, userInfo, practiceId, msg, model) {
    let msg_1, msg_10, msg_11, bind$0040_1, bind$0040_2, bind$0040, bind$0040_3, bind$0040_4, bind$0040_5;
    let matchResult, ex, practiceId_1, packages, practiceId_2, practice, media, practiceId_3, media_1, package$, updatedPackage, e, mode, setter, si, pid, crudOutbound, msg_22;
    switch (msg.tag) {
        case 1: {
            matchResult = 1;
            break;
        }
        case 2: {
            matchResult = 2;
            practiceId_1 = msg.fields[0];
            break;
        }
        case 3: {
            if (msg.fields[0].tag === 1) {
                matchResult = 14;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 3;
                packages = msg.fields[0].fields[0];
            }
            break;
        }
        case 4: {
            matchResult = 4;
            practiceId_2 = msg.fields[0];
            break;
        }
        case 5: {
            if (msg.fields[0].tag === 1) {
                matchResult = 14;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 5;
                practice = msg.fields[0].fields[0];
            }
            break;
        }
        case 6: {
            matchResult = 6;
            break;
        }
        case 7: {
            if (msg.fields[0].tag === 1) {
                matchResult = 14;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 7;
                media = msg.fields[0].fields[0];
            }
            break;
        }
        case 8: {
            matchResult = 8;
            practiceId_3 = msg.fields[0];
            break;
        }
        case 9: {
            if (msg.fields[0].tag === 1) {
                matchResult = 14;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 9;
                media_1 = msg.fields[0].fields[0];
            }
            break;
        }
        case 10: {
            matchResult = 10;
            break;
        }
        case 11: {
            if (msg.fields[0].tag === 1) {
                matchResult = 14;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 11;
                package$ = msg.fields[0].fields[0];
            }
            break;
        }
        case 12: {
            matchResult = 12;
            break;
        }
        case 13: {
            if (msg.fields[0].tag === 1) {
                matchResult = 14;
                e = msg.fields[0].fields[0];
            }
            else {
                matchResult = 13;
                updatedPackage = msg.fields[0].fields[0];
            }
            break;
        }
        case 14: {
            matchResult = 15;
            mode = msg.fields[0];
            break;
        }
        case 15: {
            matchResult = 16;
            setter = msg.fields[0];
            break;
        }
        case 16: {
            matchResult = 17;
            si = msg.fields[0];
            break;
        }
        case 17: {
            switch (msg.fields[0].tag) {
                case 3: {
                    matchResult = 18;
                    pid = msg.fields[0].fields[0];
                    break;
                }
                case 1: {
                    matchResult = 19;
                    break;
                }
                default:
                    matchResult = 20;
            }
            break;
        }
        case 18: {
            if (msg.fields[0].tag === 1) {
                matchResult = 21;
                crudOutbound = msg.fields[0].fields[0];
            }
            else {
                matchResult = 22;
                msg_22 = msg.fields[0];
            }
            break;
        }
        default: {
            matchResult = 0;
            ex = msg.fields[0];
        }
    }
    switch (matchResult) {
        case 0: {
            console.error(some(`Error: ${ex}`));
            return [model, Cmd_none()];
        }
        case 1:
            return [new Model(model.Packages, model.ParentPractice, model.SortInfo, model.SelectedPackage, model.ViewMode, userInfo.roles, model.SectionsCrudModel), Cmd_batch(ofArray([(msg_1 = (new Msg(18, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_currentRoles_())(userInfo.roles)])])])), singleton((dispatch) => {
                dispatch(msg_1);
            })), singleton((dispatch_1) => {
                dispatch_1(new Msg(2, [practiceId]));
            }), singleton((dispatch_2) => {
                dispatch_2(new Msg(4, [practiceId]));
            }), singleton((dispatch_3) => {
                dispatch_3(new Msg(6, []));
            }), singleton((dispatch_4) => {
                dispatch_4(new Msg(8, [practiceId]));
            })]))];
        case 2:
            return [model, Cmd_OfAsyncWith_either((x) => {
                AsyncHelpers_start(x);
            }, securedApi(token).getAllPackagesForPractice, practiceId_1, (Item_3) => (new Msg(3, [Item_3])), (Item_4) => (new Msg(0, [Item_4])))];
        case 3:
            return [new Model(packages, model.ParentPractice, model.SortInfo, model.SelectedPackage, model.ViewMode, model.CurrentRoles, model.SectionsCrudModel), Cmd_none()];
        case 4:
            return [model, Cmd_OfAsyncWith_either((x_1) => {
                AsyncHelpers_start(x_1);
            }, securedApi(token).getPractice, practiceId_2, (Item_5) => (new Msg(5, [Item_5])), (Item_6) => (new Msg(0, [Item_6])))];
        case 5:
            return [new Model(model.Packages, practice, model.SortInfo, model.SelectedPackage, model.ViewMode, model.CurrentRoles, model.SectionsCrudModel), Cmd_none()];
        case 6:
            return [model, Cmd_OfAsyncWith_either((x_2) => {
                AsyncHelpers_start(x_2);
            }, securedApi(token).getAllPublicMedia, undefined, (Item_7) => (new Msg(7, [Item_7])), (Item_8) => (new Msg(0, [Item_8])))];
        case 7:
            return [model, (msg_10 = (new Msg(18, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_publicMedia_())(media)])])])), singleton((dispatch_5) => {
                dispatch_5(msg_10);
            }))];
        case 8:
            return [model, Cmd_OfAsyncWith_either((x_3) => {
                AsyncHelpers_start(x_3);
            }, securedApi(token).getAllMediaForPractice, practiceId_3, (Item_12) => (new Msg(9, [Item_12])), (Item_13) => (new Msg(0, [Item_13])))];
        case 9:
            return [model, (msg_11 = (new Msg(18, [new Types_Msg$4(2, [new Shared_CrudInbound$2(4, [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), CustomShared_get_practiceMedia_())(media_1)])])])), singleton((dispatch_6) => {
                dispatch_6(msg_11);
            }))];
        case 10:
            return [model, (model.ViewMode.tag === 7) ? Cmd_OfAsyncWith_either((x_4) => {
                AsyncHelpers_start(x_4);
            }, securedApi(token).createPackage, (bind$0040_1 = model.SelectedPackage, new PackageViewModel(newGuid(), bind$0040_1.practiceId, bind$0040_1.name, bind$0040_1.description, bind$0040_1.procedure, bind$0040_1.specialty, bind$0040_1.language, bind$0040_1.title, bind$0040_1.intro, bind$0040_1.sections, bind$0040_1.outro)), (Item_17) => (new Msg(11, [Item_17])), (Item_18) => (new Msg(0, [Item_18]))) : error("Must be on the Create view to create")];
        case 11:
            return [new Model(cons(package$, model.Packages), model.ParentPractice, model.SortInfo, model.SelectedPackage, model.ViewMode, model.CurrentRoles, model.SectionsCrudModel), singleton((dispatch_7) => {
                dispatch_7(new Msg(14, [new ViewMode_1(0, [])]));
            })];
        case 12:
            return [model, Cmd_OfAsyncWith_either((x_5) => {
                AsyncHelpers_start(x_5);
            }, securedApi(token).editPackage, model.SelectedPackage, (Item_19) => (new Msg(13, [Item_19])), (Item_20) => (new Msg(0, [Item_20])))];
        case 13:
            return [new Model(map((package$_1) => {
                if (package$_1.packageId === updatedPackage.packageId) {
                    return updatedPackage;
                }
                else {
                    return package$_1;
                }
            }, model.Packages), model.ParentPractice, model.SortInfo, model.SelectedPackage, model.ViewMode, model.CurrentRoles, model.SectionsCrudModel), Cmd_batch(ofArray([success("Successfully updated package"), singleton((dispatch_8) => {
                dispatch_8(new Msg(2, [updatedPackage.practiceId]));
            })]))];
        case 14:
            return [model, error(ErrorMessage_get_describe()(e))];
        case 15:
            switch (mode.tag) {
                case 3:
                    return [new Model(model.Packages, model.ParentPractice, model.SortInfo, (bind$0040_2 = emptyPackageWithDefaults(model.ParentPractice), new PackageViewModel(bind$0040_2.packageId, practiceId, bind$0040_2.name, bind$0040_2.description, bind$0040_2.procedure, bind$0040_2.specialty, bind$0040_2.language, bind$0040_2.title, bind$0040_2.intro, bind$0040_2.sections, bind$0040_2.outro)), mode, model.CurrentRoles, model.SectionsCrudModel), Cmd_none()];
                case 2:
                    return [new Model(model.Packages, model.ParentPractice, model.SortInfo, model.SelectedPackage, mode, model.CurrentRoles, model.SectionsCrudModel), Cmd_none()];
                case 6:
                case 7:
                case 4:
                case 5:
                    return [new Model(model.Packages, model.ParentPractice, model.SortInfo, model.SelectedPackage, mode, model.CurrentRoles, model.SectionsCrudModel), singleton((dispatch_9) => {
                        dispatch_9(new Msg(18, [new Types_Msg$4(2, [new Shared_CrudInbound$2(0, [model.SelectedPackage.sections])])]));
                    })];
                case 0:
                    return [new Model(model.Packages, model.ParentPractice, model.SortInfo, (bind$0040 = emptyPackageWithDefaults(model.ParentPractice), new PackageViewModel(bind$0040.packageId, practiceId, bind$0040.name, bind$0040.description, bind$0040.procedure, bind$0040.specialty, bind$0040.language, bind$0040.title, bind$0040.intro, bind$0040.sections, bind$0040.outro)), new ViewMode_1(0, []), model.CurrentRoles, model.SectionsCrudModel), Cmd_none()];
                default:
                    return [new Model(model.Packages, model.ParentPractice, model.SortInfo, mode.fields[0], mode, model.CurrentRoles, model.SectionsCrudModel), Cmd_none()];
            }
        case 16:
            return [new Model(model.Packages, model.ParentPractice, model.SortInfo, setter(model.SelectedPackage), model.ViewMode, model.CurrentRoles, model.SectionsCrudModel), Cmd_none()];
        case 17:
            return [new Model(model.Packages, model.ParentPractice, si, model.SelectedPackage, model.ViewMode, model.CurrentRoles, model.SectionsCrudModel), Cmd_none()];
        case 18:
            return [model, (practiceId === pid) ? singleton((dispatch_10) => {
                dispatch_10(new Msg(2, [practiceId]));
            }) : Cmd_none()];
        case 19:
            return [model, singleton((dispatch_11) => {
                dispatch_11(new Msg(4, [practiceId]));
            })];
        case 20:
            return [model, Cmd_none()];
        case 21:
            switch (crudOutbound.tag) {
                case 1:
                    return [model, error("An unexpected error occurred. Please try again.")];
                case 2: {
                    const section = crudOutbound.fields[0];
                    const section_1 = new SectionViewModel(newGuid(), section.mediaId, section.mediaSpecialtyFilter, section.sectionHeading, section.sectionContents);
                    return [new Model(model.Packages, model.ParentPractice, model.SortInfo, (bind$0040_3 = model.SelectedPackage, new PackageViewModel(bind$0040_3.packageId, bind$0040_3.practiceId, bind$0040_3.name, bind$0040_3.description, bind$0040_3.procedure, bind$0040_3.specialty, bind$0040_3.language, bind$0040_3.title, bind$0040_3.intro, append_1(model.SelectedPackage.sections, singleton(section_1)), bind$0040_3.outro)), model.ViewMode, model.CurrentRoles, model.SectionsCrudModel), singleton((dispatch_12) => {
                        dispatch_12(new Msg(18, [new Types_Msg$4(0, [new StateMachineMsg$5(0, [new CrudStateMachine_CrudTaggedStateMessages$4(0, [new InternalMsg$4(3, [new FSharpResult$2(0, [section_1])])])])])]));
                    })];
                }
                case 3: {
                    const section_2 = crudOutbound.fields[0];
                    return [new Model(model.Packages, model.ParentPractice, model.SortInfo, (bind$0040_4 = model.SelectedPackage, new PackageViewModel(bind$0040_4.packageId, bind$0040_4.practiceId, bind$0040_4.name, bind$0040_4.description, bind$0040_4.procedure, bind$0040_4.specialty, bind$0040_4.language, bind$0040_4.title, bind$0040_4.intro, map((s) => {
                        if (s.sectionId === section_2.sectionId) {
                            return section_2;
                        }
                        else {
                            return s;
                        }
                    }, model.SelectedPackage.sections), bind$0040_4.outro)), model.ViewMode, model.CurrentRoles, model.SectionsCrudModel), singleton((dispatch_13) => {
                        dispatch_13(new Msg(18, [new Types_Msg$4(0, [new StateMachineMsg$5(0, [new CrudStateMachine_CrudTaggedStateMessages$4(1, [new InternalMsg$4(3, [new FSharpResult$2(0, [section_2])])])])])]));
                    })];
                }
                case 4:
                    return [new Model(model.Packages, model.ParentPractice, model.SortInfo, (bind$0040_5 = model.SelectedPackage, new PackageViewModel(bind$0040_5.packageId, bind$0040_5.practiceId, bind$0040_5.name, bind$0040_5.description, bind$0040_5.procedure, bind$0040_5.specialty, bind$0040_5.language, bind$0040_5.title, bind$0040_5.intro, filter((s_1) => (s_1.sectionId !== crudOutbound.fields[0].sectionId), model.SelectedPackage.sections), bind$0040_5.outro)), model.ViewMode, model.CurrentRoles, model.SectionsCrudModel), singleton((dispatch_14) => {
                        dispatch_14(new Msg(18, [new Types_Msg$4(0, [new StateMachineMsg$5(0, [new CrudStateMachine_CrudTaggedStateMessages$4(4, [new InternalMsg$4_1(2, [new FSharpResult$2(0, [undefined])])])])])]));
                    })];
                default:
                    return [model, error(ErrorMessage_get_describe()(crudOutbound.fields[0]))];
            }
        default: {
            const patternInput = State_update(new SectionsUpdateArgs(token), msg_22, model.SectionsCrudModel);
            return [new Model(model.Packages, model.ParentPractice, model.SortInfo, model.SelectedPackage, model.ViewMode, model.CurrentRoles, patternInput[0]), Cmd_map((Item_36) => (new Msg(18, [Item_36])), patternInput[1])];
        }
    }
}

